import { Col, Form, Input, Row, Tabs } from "antd"
import { useMemo, useState } from "react"

import StaffNotesThread from "#components/StaffNotes/StaffNotesThread"
import { RESOURCES, USER_ACTIONS } from "#customTypes/composedTypes/authTypes"
import { AddUserFormValues } from "#customTypes/composedTypes/userTypes"
import useHasPermission from "#hooks/newHooks/useHasPermission"

import TeacherInfo from "./TeacherInfo"
import UserDetails from "./UserDetails"
import UserInfo from "./UserInfo"

const TABS = {
  DETAILS: "Details",
  TEACHER_INFO: "Teacher Info",
  STAFF_NOTES: "Staff Notes",
}

const UserProfile = ({
  initialValues,
}: {
  initialValues: AddUserFormValues
}) => {
  const defaultTab = initialValues.pinHash ? TABS.TEACHER_INFO : TABS.DETAILS
  const [activeTab, setActiveTab] = useState(defaultTab)
  const canReadStaffNotes = useHasPermission(
    RESOURCES.STAFF_NOTE,
    USER_ACTIONS.READ
  )

  const tabItems = useMemo(() => {
    const items = [
      {
        key: TABS.DETAILS,
        label: TABS.DETAILS,
        children: <UserDetails />,
      },
      {
        key: TABS.TEACHER_INFO,
        label: TABS.TEACHER_INFO,
        children: <TeacherInfo />,
      },
    ]

    if (initialValues.id && canReadStaffNotes) {
      items.push({
        key: TABS.STAFF_NOTES,
        label: TABS.STAFF_NOTES,
        children: (
          <div data-testid="staff-notes-tab">
            <StaffNotesThread subjectUserId={initialValues.id} />
          </div>
        ),
      })
    }

    return items
  }, [canReadStaffNotes, initialValues.id])

  return (
    <Row gutter={40}>
      <Col span={6}>
        <UserInfo initialValues={initialValues} />
      </Col>
      <Col span={18}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
      </Col>

      <Form.Item name="id" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="avatar" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="name" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
    </Row>
  )
}

export default UserProfile
